module.exports = __webpack_public_path__ + "fda008900afa2b5864fcec9faab2556d.MP3";